import { useEffect, useState } from "react";
import { useMempadTokenInfo } from "@/hooks/useMempadTokenInfo";
import { MempadTokenInfo } from "@/api/WalletController";

/**
 * Hook to fetch mempad token info for an array of snipes (memePad only)
 * Returns a map of snipe.guid => mempad token info (or null if not meme)
 */
export function useMempadTokenInfoForSnipes(snipes: Array<{ guid: string; mempadType?: number; assetOutInfo?: { jettonMasterAddress?: string } }>) {
  // Map: snipe GUID => mempad token info or null
  const [infoMap, setInfoMap] = useState<Record<string, MempadTokenInfo | null>>({});
  const [loadingMap, setLoadingMap] = useState<Record<string, boolean>>({});
  const [errorMap, setErrorMap] = useState<Record<string, string | null>>({});

  useEffect(() => {
    const memeSnipes = snipes.filter(s => s.mempadType && s.assetOutInfo?.jettonMasterAddress);
    memeSnipes.forEach(snipe => {
      const address = snipe.assetOutInfo!.jettonMasterAddress!;
      setLoadingMap(prev => ({ ...prev, [snipe.guid]: true }));
      setErrorMap(prev => ({ ...prev, [snipe.guid]: null }));
      import("@/api/WalletController").then(({ WalletController }) => {
        WalletController.getMempadTokenInfo(address)
          .then(res => {
            if (res.status === "success" && res.data) {
              setInfoMap(prev => ({ ...prev, [snipe.guid]: res.data }));
            } else {
              setErrorMap(prev => ({ ...prev, [snipe.guid]: res.message || "Unknown error" }));
              setInfoMap(prev => ({ ...prev, [snipe.guid]: null }));
            }
          })
          .catch(e => {
            setErrorMap(prev => ({ ...prev, [snipe.guid]: e.message || "Failed to fetch info" }));
            setInfoMap(prev => ({ ...prev, [snipe.guid]: null }));
          })
          .finally(() => {
            setLoadingMap(prev => ({ ...prev, [snipe.guid]: false }));
          });
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(snipes.map(s => [s.guid, s.mempadType, s.assetOutInfo?.jettonMasterAddress]))]);

  return { infoMap, loadingMap, errorMap };
}
